import type { ApiResponse, SettingPayload } from "interface/setting";
import * as API from "@utils/apiPath";
import { baseApi } from "./baseApi";

export const settingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSetting: builder.query<ApiResponse, void>({
      query: () => ({
        url: API.GET_SETTING,
        method: "GET",
      }),
      providesTags: ["Setting"],
    }),
    updateSetting: builder.mutation<ApiResponse, SettingPayload>({
      query: ({ params }) => ({
        url: API.GET_SETTING,
        method: "PUT",
        body: params,
      }),
      invalidatesTags: ["Setting"],
    }),
    updateSettingLogo: builder.mutation<ApiResponse, FormData>({
      query: (body) => ({
        url: API.UPDATE_SETTING_LOGO,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetSettingQuery,
  useUpdateSettingMutation,
  useUpdateSettingLogoMutation,
} = settingApi;
